import api from './api';

// Interface for user booking data returned by API
export interface UserBooking {
  _id: string;
  retreat: any;
  personalInfo: {
    name: string;
    phoneNumber: string;
    email: string;
    notificationPreference: string;
    message?: string;
  };
  selectedDate: {
    startDate: string;
    endDate: string;
  };
  numberOfGuests: number;
  guests: {
    name: string;
    email: string;
    phoneNumber: string;
  }[];
  selectedAccommodation: string;
  paymentInfo: {
    paymentType: 'full' | 'partial';
    paymentMethod: 'card' | 'bank_transfer';
    currency: string;
    cardInfo?: {
      cardNumber: string;
      expiryMonth: string;
      expiryYear: string;
      cvv: string;
      nameOnCard: string;
    };
  };
  bookingReference: string;
  specialRequests?: string;
  carbonOffset?: boolean;
  bookingStatus: 'pending' | 'confirmed' | 'cancelled' | 'completed' | 'draft';
  totalAmount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface UserBookingsResponse {
  statusCode: number;
  message: string;
  data: {
    data: UserBooking[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  };
}

export interface ApiResponse<T> {
  statusCode: number;
  message: string;
  data: T;
}

const userBookingService = {
  // Get all bookings for the authenticated user
  getUserBookings: async (): Promise<UserBookingsResponse> => {
    const response = await api.get('/booking/user');
    return response.data;
  },

  // Get a specific booking by ID
  getBookingById: async (bookingId: string): Promise<ApiResponse<UserBooking>> => {
    const response = await api.get(`/booking/${bookingId}`);
    return response.data;
  },

  // Cancel a booking
  cancelBooking: async (bookingId: string): Promise<ApiResponse<UserBooking>> => {
    const response = await api.patch(`/booking/${bookingId}/cancel`);
    return response.data;
  },

  // Update booking details
  updateBooking: async (bookingId: string, updateData: Partial<UserBooking>): Promise<ApiResponse<UserBooking>> => {
    const response = await api.patch(`/booking/${bookingId}`, updateData);
    return response.data;
  }
};

export default userBookingService;